import { render } from "./orderClear.vue?vue&type=template&id=e6c8ec7e&scoped=true"
import script from "./orderClear.vue?vue&type=script&lang=js"
export * from "./orderClear.vue?vue&type=script&lang=js"

import "./orderClear.vue?vue&type=style&index=0&id=e6c8ec7e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c8ec7e"]])

export default __exports__